import React from "react";
import { UserFacingError } from "../store/types";

interface ErrorToastProps {
  error: UserFacingError | null;
  onDismiss: () => void;
}

const severityColor: Record<UserFacingError["severity"], string> = {
  error: "#dc2626",
  warning: "#d97706",
  info: "#2563eb",
};

const severityLabel: Record<UserFacingError["severity"], string> = {
  error: "Fehler",
  warning: "Warnung",
  info: "Hinweis",
};

const ErrorToast: React.FC<ErrorToastProps> = ({ error, onDismiss }) => {
  if (!error) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        position: "fixed",
        bottom: 24,
        left: "50%",
        transform: "translateX(-50%)",
        maxWidth: 420,
        width: "calc(100% - 32px)",
        background: "#ffffff",
        color: "#111827",
        borderLeft: `4px solid ${severityColor[error.severity]}`,
        borderRadius: 10,
        boxShadow: "0 10px 25px rgba(0,0,0,0.15), 0 4px 10px rgba(0,0,0,0.08)",
        padding: "14px 16px",
        fontFamily:
          "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        fontSize: 14,
        lineHeight: 1.45,
        zIndex: 2147483000,
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontWeight: 600,
              marginBottom: 4,
              color: severityColor[error.severity],
            }}
          >
            <span style={{ opacity: 0.7, marginRight: 6 }}>
              {severityLabel[error.severity]}·
            </span>
            {error.title}
          </div>
          <div style={{ color: "#374151" }}>{error.body}</div>
        </div>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Meldung schließen"
          style={{
            background: "transparent",
            border: "none",
            color: "#6b7280",
            cursor: "pointer",
            fontSize: 20,
            lineHeight: 1,
            padding: 0,
            marginLeft: 4,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ErrorToast;
